const geolocationPermissionCheck = () => {
  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };
  return new Promise((resolve, reject) => {
    function success(position) {
      resolve(position);
    }
    function error(err) {
      reject(err);
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    navigator.geolocation.getCurrentPosition(success, error, options);
  });
}

export {
  geolocationPermissionCheck
}